import { Box, Grid2 } from "@mui/material";
import { LoginViewModel } from "./LoginViewModel";
import { APP_ICON_IMAGE_WITHOUT_TITLE } from "../../../../data/constant/Constants";
import { CustomImageView } from "../../../component/CustomImageView";
import LoginForm from "./LoginForm";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { provideLoginUseCase } from "../../../di/UseCasesModule";
import { useTranslation } from "react-i18next";

export default function LoginView() {
  const { login } = LoginViewModel(provideLoginUseCase());
  const { width } = useWindowDimensions();

  const { i18n } = useTranslation();
  return (
    <Box>
      <Grid2 container>
        <Grid2
          size={{ xs: 0, sm: 0, md: 6, lg: 8, xl: 8 }}
          sx={{
            width: width > 900 ? "100%" : "0%",
            height: width > 900 ? "100%" : "0%",
          }}
        >
          <Box
            sx={{
              height: "100vh",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <CustomImageView
              width={"100%"}
              height={"100%"}
              src={APP_ICON_IMAGE_WITHOUT_TITLE}
              props={{
                borderTopRightRadius: i18n.dir() == "ltr" ? 80 : 0,
                borderBottomRightRadius: i18n.dir() == "ltr" ? 80 : 0,
                borderTopLeftRadius: i18n.dir() == "rtl" ? 80 : 0,
                borderBottomLeftRadius: i18n.dir() == "rtl" ? 80 : 0,
                background: "#750832",
              }}
            />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
          <LoginForm onSubmit={login} />
        </Grid2>
      </Grid2>
    </Box>
  );
}
